export async function requestFactory(
  bankName,
  apiName,
  userDetails,
  ...extraInfo
) {
  try {
    let module;
    switch (bankName.toLowerCase()) {
      case "axis":
        module = await import("../Axis/RequestMapper.js");
        break;
      case "kotak":
        module = await import("../Kotak/RequestMapper.js");
        break;
      default:
        throw new Error(`Unsupported bank: ${bankName}`);
    }

    if (!module || typeof module.default !== "function") {
      throw new Error(`Mapper not exported as default for bank: ${bankName}`);
    }
    const apiMapper = module.default;

    if (!apiMapper) {
      throw new Error(
        `API mapper not found for API: ${apiName} in bank: ${bankName}`
      );
    }
    return apiMapper(apiName, userDetails, extraInfo);
  } catch (error) {
    throw new Error(
      `Failed to load mapper for bank: ${bankName}. ${error.message}`
    );
  }
}
